import * as React from 'react';

import { useTabSwitcher } from '@sharedComponents/TabSwitcher/context/TabSwitcherContext';

export const useResetOpenTabOnProductChange = (productId: string | number) => {
  const { setActiveTab, tabs } = useTabSwitcher();
  const firstTab = tabs?.[0];

  React.useEffect(() => {
    if (!firstTab) {
      return;
    }
    setActiveTab(firstTab?.id);
  }, [productId, setActiveTab, firstTab]);
};
